<div class="row">
    <div class="col-sm-12 text-center">
        <div  class="card sign-in-forms">

            <div class="text-center">

                <img src="/assets/images/happymath.jpg" width="100%"/>
            </div>
            <ul class = "mt-5 non-style">
                <li>
                    <h4 class="text-success"> <i class = "fa fa-check-circle"></i> {{userMessage}}</h4>
                </li>
                <li>
                    <h4 class="text-success"> <i class = "fa fa-check-circle"></i> Check your email for the activation code</h4>
                </li>
                <li>
                    <h4 class="text-success"> <i class = "fa fa-check-circle"></i> Account verified successfully!</h4>
                </li>
            </ul>

            <div class ="text-center mt-5 mb-3">
                <a [routerLink]="['/user/login']" class="btn-primary btn-lg">Login</a>
            </div>
     </div>

</div>
</div>


